<template>
  <div class="avatar-item">
    <img :src="getAssetsPath(srcPath)" alt="avatar" />
  </div>
</template>

<script>
import { getAssetsPath } from "@/utils/getCorrectPath";

export default {
  name: "AvatarItem",
  props: {
    srcPath: {
      type: String,
      required: true,
    },
  },
  methods: { getAssetsPath },
};
</script>

<style scoped lang="scss">
.avatar-item {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  overflow: hidden;
  background: var(--colors-purple-500);
  border: 1.2px solid var(--colors-purple-500);
  display: flex;
  align-items: center;
  justify-content: center;

  &:not(:first-child) {
    margin-left: -7px;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
</style>
